import { RiAddFill } from 'react-icons/ri'
import { BiTrash } from 'react-icons/bi'
import { BiSolidUpArrow } from 'react-icons/bi'
import { RiDeleteBinLine } from 'react-icons/ri'
import { separate } from '../../../PaymentHistory'
import { useEffect, useState } from 'react'
import { sell_types_subject, types_subject } from '../../../../api/api'
import axios from 'axios'
import { toast } from 'react-toastify'

import RichTextEditor from './RichTextEditor'
import UploadCodes from './UploadCode'
import { CUSTOM_TITLE_VALUE, VIDEO_LINK_TITLE_OPTIONS } from './videoHelper'

const mod = {
     toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote'],
          [{ 'header': 1 }, { 'header': 2 }],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'direction': 'rtl' }],
          [{ 'size': ['small', false, 'large', 'huge'] }],
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'font': [] }],
          [{ 'align': [] }],
     ],
}

const persentCalculator = (persent, price) => separate((parseInt(price) * parseFloat(persent) / 100).toFixed(0))



const createEmptyLink = (isVideo = false) => {
     if (!isVideo) {
          return {
               link: '',
               size: '',
          }
     }

     return {
          link: '',
          size: '',
          title: VIDEO_LINK_TITLE_OPTIONS[0].value,
          titleOption: VIDEO_LINK_TITLE_OPTIONS[0].value,
          customTitle: '',
     }
}

const LinkInputs = ({
     data,
     setData,
     refUploadCode,
     isVideo = false,
}) => {

     const [typesLang, setTypesLang] = useState([])
     const [typeSell, setTypeSell] = useState([])


     const addBox = () => {
          let oldLinks = [...data]
          oldLinks.push({
               title: '',
               producerShare: 0,
               publisherShare: 0,
               paymentTitle: '',
               paymentDescription: '',
               activationKeyMediaIds: [],
               branchLinks: [{
                    price: 0,
                    downloadLinks: [
                         {
                              type: 0,
                              links: [
                                   createEmptyLink(isVideo)
                              ]
                         }
                    ]
               }]
          })
          setData(oldLinks)
     }


     const addInput = (index) => {
          let oldLinks = [...data]
          oldLinks[index].branchLinks[0].downloadLinks[0].links.push(createEmptyLink(isVideo))
          setData(oldLinks)
     }

     const handleDelete = (id) => {
          let array = [...data]
          array.splice(id, 1);
          setData(array)
     }

     const removeInput = (box, id) => {
          let array = [...data]
          array[box].branchLinks[0].downloadLinks[0].links.splice(id, 1);
          setData(array)
     }


     const updateLinkField = (box, linkIndex, field, value) => {
          const oldLinks = [...data]
          oldLinks[box].branchLinks[0].downloadLinks[0].links[linkIndex][field] = value
          setData(oldLinks)
     }

     const handleChangeLink = (e, box) => {
          e.preventDefault()
          const index = e.target.id
          updateLinkField(box, index, 'link', e.target.value)
     }

     const handleChangeSize = (e, box) => {
          e.preventDefault()
          const index = e.target.id
          updateLinkField(box, index, 'size', e.target.value)
     }

     const handleChangeLinkTitleOption = (value, box, linkIndex) => {
          const oldLinks = [...data]
          const linkItem = oldLinks[box].branchLinks[0].downloadLinks[0].links[linkIndex]
          linkItem.titleOption = value

          if (value === CUSTOM_TITLE_VALUE) {
               linkItem.title = linkItem.customTitle || ''
          } else {
               linkItem.title = value
               linkItem.customTitle = ''
          }

          setData(oldLinks)
     }

     const handleChangeCustomTitle = (value, box, linkIndex) => {
          const oldLinks = [...data]
          const linkItem = oldLinks[box].branchLinks[0].downloadLinks[0].links[linkIndex]
          linkItem.customTitle = value
          linkItem.title = value
          setData(oldLinks)
     }

     const handleSale = (val, index) => {
          let oldLinks = [...data]
          oldLinks[index].branchLinks[0].price = val === '0' ? 0 : 1
          setData(oldLinks)

     }

     const handlePrice = (val, index) => {
          const value = parseInt(val)
          let oldLinks = [...data]
          oldLinks[index].branchLinks[0].price = value
          setData(oldLinks)
     }

     const handleMaxAllowedPublisherShare = (val, index) => {
          const value = parseInt(val)
          let oldLinks = [...data]
          oldLinks[index].maxAllowedPublisherShare = value
          setData(oldLinks)
     }

     const handleZaban = (val, index) => {
          const value = parseInt(val)
          let oldLinks = [...data]
          oldLinks[index].branchLinks[0].downloadLinks[0].type = value
          setData(oldLinks)
     }

     const handleTitle = (val, index) => {
          const value = val
          let oldLinks = [...data]
          oldLinks[index].title = value
          setData(oldLinks)
     }
     const handlePublisherShare = (val, index) => {
          const value = val
          let oldLinks = [...data]
          oldLinks[index].publisherShare = value
          setData(oldLinks)
     }
     const handleProducerShare = (val, index) => {
          const value = val
          let oldLinks = [...data]
          oldLinks[index].producerShare = value
          setData(oldLinks)
     }
     const handlePaymentTitle = (val, index) => {
          const value = val
          let oldLinks = [...data]
          oldLinks[index].paymentTitle = value
          setData(oldLinks)
     }
     const handlePaymentDescription = (val, index) => {
          const value = val
          let oldLinks = [...data]
          oldLinks[index].paymentDescription = value
          setData(oldLinks)
     }
     const handleUploadedCodes = (val, index) => {
          const value = val
          let oldLinks = [...data]
          oldLinks[index].activationKeyMediaIds = value
          setData(oldLinks)
     }

     const handleCloseUp = (val) => {
          const el = document.getElementById(`box_${val}`)
          const btn = document.getElementById(`bt_${val}`)

          if (el.classList.contains('deactive')) {
               el.classList.remove('deactive')
               el.style.display = 'block'
               btn.style.transform = "rotate(0deg)";
          } else {
               btn.style.transform = "rotate(180deg)";
               el.classList.add('deactive')
               el.style.display = 'none'
          }

     }


     useEffect(() => {
          const getTypes = async () => {
               try {
                    const res = await axios.get(types_subject())
                    setTypesLang(res.data);
                    const res2 = await axios.get(sell_types_subject())
                    setTypeSell(res2.data);
               } catch (error) {
                    console.log(error);
               }
          }
          getTypes()
     }, [])



     const checkPercents = (val_1 = 0, val_2 = 0) => {
          const value_1 = val_1 ? parseFloat(val_1) : 0
          const value_2 = val_2 ? parseFloat(val_2) : 0
          const percents = value_1 + value_2
          if (percents > 100) toast.error('درصد سهم ناش و تولید کننده نباید بیشتر از 100 باشد.')
          return (100 - percents)
     }

     // console.log(data);


     return (
          <div className="dlContainer">
               <div>
                    {data.map((items, index) => items.branchLinks[0] && (
                         <div style={{ display: data.length > 0 ? '' : 'none' }} className='linksBox' key={index}>
                              <div className="buttonsBox">
                                   <button type='button' onClick={() => handleDelete(index)} style={{ color: '#F44336', fontSize: 18 }}><RiDeleteBinLine /></button>
                                   <button type='button' id={`bt_${index}`} onClick={() => handleCloseUp(index)}><BiSolidUpArrow /></button>
                              </div>

                              <div className='d-flex gap-3'>
                                   <input type="text" name="title" id="title" placeholder='عنوان' onChange={(e) => handleTitle(e.target.value, index)} value={items.title} />
                              </div>

                              <div id={`box_${index}`}>
                                   <div style={{ borderBottom: '1px solid #e4e4e4', paddingBottom: 15, marginBottom: 25 }}>

                                        <div className='d-flex gap-3'>
                                             <select name="zaban" id="zaban" onChange={(e) => handleZaban(e.target.value, index)} value={items.branchLinks[0]?.downloadLinks[0]?.type}>
                                                  {typesLang?.map(item => (
                                                       <option key={item.id} value={item.id}>{item.title}</option>
                                                  ))}
                                             </select>
                                             <select name="sale" id="sale" onChange={(e) => handleSale(e.target.value, index)} value={items.branchLinks[0]?.price === 0 ? 0 : 1}>
                                                  {typeSell?.map(item => (
                                                       <option key={item.id} value={item.id}>{item.title}</option>
                                                  ))}
                                             </select>
                                        </div>

                                        {items.branchLinks[0]?.price !== 0 && <div>
                                             <div className='flex gap-2'>

                                                  <p style={{ width: '25%' }}>
                                                       <input type="number" name="price" id="price" placeholder='قیمت فروش را به ریال وارد کنید' value={items.branchLinks[0]?.price > 0 ? items.branchLinks[0]?.price : ''} onChange={(e) => handlePrice(e.target.value, index)} />
                                                       {items.branchLinks[0]?.price > 0 && <span><small>قیمت</small> {separate(items.branchLinks[0]?.price)} <small>ریال</small></span>}
                                                  </p>
                                                  <p style={{ width: '25%' }}>
                                                       <input name='PublisherShare' value={items.publisherShare} onChange={(e) => handlePublisherShare(e.target.value, index)} id='PublisherShare' min={0} max={100} type="number" placeholder="به درصد وارد کنید" />
                                                       <span>
                                                            {items.publisherShare}% <small>سهم ناشر</small>
                                                            {items.branchLinks[0]?.price > 0 && <small style={{ fontSize: 12.5, fontWeight: 300 }}> ({persentCalculator(items.publisherShare, items.branchLinks[0]?.price)} ریال)</small>}
                                                       </span>

                                                  </p>
                                                  <p style={{ width: '25%' }}>
                                                       <input name='ProducerShare' value={items.producerShare} onChange={(e) => handleProducerShare(e.target.value, index)} id='ProducerShare' min={0} max={100} type="number" placeholder="به درصد وارد کنید" />
                                                       <span>
                                                            {items.producerShare}% <small>سهم تولید کننده</small>
                                                            {items.branchLinks[0]?.price > 0 && <small style={{ fontSize: 12.5, fontWeight: 300 }}> ({persentCalculator(items.producerShare, items.branchLinks[0]?.price)} ریال)</small>}
                                                       </span>
                                                  </p>
                                                  <p style={{ width: '25%' }}>
                                                       <input name='siteShare' id='siteShare' value={checkPercents(items.publisherShare, items.producerShare)} onChange={(e) => { }} type="text" placeholder="سهم سایت به درصد" readOnly />
                                                       <span>
                                                            {checkPercents(items.publisherShare, items.producerShare)}% <small>سهم سایت</small>
                                                            {items.branchLinks[0]?.price > 0 && <small style={{ fontSize: 12.5, fontWeight: 300 }}> ({persentCalculator(checkPercents(items.publisherShare, items.producerShare), items.branchLinks[0]?.price)} ریال)</small>}
                                                       </span>
                                                  </p>
                                             </div>

                                             <p>
                                                  <input type="number" name="maxAllowedPublisherShare" id="maxAllowedPublisherShare" placeholder='سقف قیمت' value={items.maxAllowedPublisherShare > 0 ? items.maxAllowedPublisherShare : ''} onChange={(e) => handleMaxAllowedPublisherShare(e.target.value, index)} />
                                                  {items.maxAllowedPublisherShare > 0 && <span><small>قیمت</small> {separate(items.maxAllowedPublisherShare)} <small>ریال</small></span>}
                                             </p>


                                             <hr style={{ opacity: .1 }} />
                                             <UploadCodes pullBack={handleUploadedCodes} indexLinks={index} haveActivationKey={items.haveActivationKey} ref={refUploadCode} subjectBranchId={data[index]?.id} />
                                             <hr style={{ opacity: .1 }} />


                                             <div className='PaymentDetails'>
                                                  <p><input name='paymentTitle' type="text" placeholder="عنوان صفحه پرداخت" value={items.paymentTitle ? items.paymentTitle : ''} onChange={(e) => handlePaymentTitle(e.target.value, index)} /></p>
                                                  <div className='textEditor'>
                                                       <RichTextEditor
                                                            value={items.paymentDescription ? items.paymentDescription : ''}
                                                            onChange={(value) => handlePaymentDescription(value, index)}
                                                            modules={mod}
                                                            maxLength={3000}
                                                       />
                                                  </div>
                                             </div>


                                        </div>}
                                   </div>

                                   {items.branchLinks[0]?.downloadLinks[0] && items.branchLinks[0]?.downloadLinks[0]?.links.map((item, i) => {
                                        const isCustomTitle = isVideo && item.titleOption === CUSTOM_TITLE_VALUE

                                        return (
                                             <div
                                                  className="downloadInputs"
                                                  key={i}
                                                  {...(isVideo ? {} : { counter: i + 1 })}
                                             >
                                                  {isVideo && (
                                                       <div className="linkTitle">
                                                            <select
                                                                 value={item.titleOption || VIDEO_LINK_TITLE_OPTIONS[0].value}
                                                                 onChange={(e) => handleChangeLinkTitleOption(e.target.value, index, i)}
                                                            >
                                                                 {VIDEO_LINK_TITLE_OPTIONS.map((option) => (
                                                                      <option key={option.value} value={option.value}>
                                                                           {option.label}
                                                                      </option>
                                                                 ))}
                                                            </select>
                                                            {isCustomTitle && (
                                                                 <input
                                                                      type="text"
                                                                      placeholder="عنوان دلخواه"
                                                                      value={item.customTitle || ''}
                                                                      onChange={(e) => handleChangeCustomTitle(e.target.value, index, i)}
                                                                      required
                                                                 />
                                                            )}
                                                       </div>
                                                  )}
                                                  <div className="url"><input onChange={(e) => handleChangeLink(e, index)} value={item.link} id={i} box={index} type='url' placeholder='url : http://...' className='ltr' required /></div>
                                                  <div className="size"><input onChange={(e) => handleChangeSize(e, index)} value={item.size > 0 ? item.size : ''} id={i} box={index} type='number' placeholder='size : MB' className='ltr' required /></div>
                                                  <div className="add"><button type='button' onClick={() => removeInput(index, i)} className='removeOne'><BiTrash /></button></div>
                                             </div>
                                        )
                                   })}

                                   <div className="addMoreLinks">
                                        <div className="add"><button style={{ background: '#fff', border: '2px solid', fontWeight: 600, }} type='button' onClick={() => addInput(index)} className='addMore'><RiAddFill /> لینک جدید</button></div>
                                   </div>
                              </div>
                         </div>
                    ))}

                    <div className="addMoreLinks">
                         <div className="add"><button type='button' onClick={addBox} className='addMore'><RiAddFill /> باکس دانلود جدید</button></div>
                    </div>
               </div>
          </div>
     )
}

export default LinkInputs